import React, { useState, useEffect, useRef } from "react";
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux"
import {  useParams } from "react-router-dom";
import Table from 'react-bootstrap/Table';

import Footer from "../../Components/footer";
import Header from "../../Components/header";
import "../../assets/css/style.scss";
import "./index.scss"
import LogoInvoice from "../../assets/images/order-logo.png";
import { ReactComponent as DownloadIcon } from '../../assets/images/downlaod-icon.svg';
import { getOrder } from '../../Services/Order'


import { PDFDownloadLink } from "@react-pdf/renderer";
import InvoiceForDownload from "../../Components/Invoice/InvoiceForDownload";





const Cartpage = () => {
  const dispatch = useDispatch();
  let { id } = useParams();

  const { cart } = useSelector((state) => state.cart)
  const [order, setOrder] = useState({

  });
  const [carts, setCarts] = useState([]);
  const [loading, setLoading] = useState(false);

  const printRef = useRef();



  useEffect(() => {
    getOrdersData()
    setCarts(cart)
  }, [cart])


  let getOrdersData = async () => {
    const response = await getOrder(id);
    if(response.data){
      setOrder(response.data)
    }
  }

  console.log("orderorder ---0000--==>>", order)
  return (
    <>
      <div className="wrapper">
        <Header />
        <div className="cart-page-wapper py-5">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="invoice-wrapper">
                  <div className="heading-topbar-elemnt mb-4">
                    <h2 className="title-main-order">Invoice</h2>
                  </div>
                  <div className="order-bodycontainer">
                    <div className="step-oder1">
                      <div className="row align-items-center">
                        <div className="col-12 col-md-6">
                          <div className="heading-invoice-wgt">
                            <h3 className="title-invc">INVOICE</h3>
                            <div className="d-flex align-items-center">
                              <label className="lbl-st-txt">STATUS</label>
                              <span className="txt-status-invoice">{
                                order.paymentStatus
                              }</span>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="address-content-wgt">
                            <div className="logo-brand-invice mb-2"><img src={LogoInvoice} alt="Image" /> <span className="logotxt-name">OwnEzzy</span></div>
                            <ul className="multi-adrs-wt">
                              <li className="item-addres">Bambali, Sédhiou, Senegal</li>
                              <li className="item-addres">01957930034</li>
                              <li className="item-addres"><a href="mailto:htmllover@gmail.com">htmllover@gmail.com</a></li>
                              <li className="item-addres">ownezzy.com</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="step-oder2">
                      <div className="row">
                        <div className="col-12 col-md-4">
                          <div className="wgthead--elemnt">
                            <h4 className="sub-title-invoce">DATE</h4>
                            <span className="ttx-small-mtw">
                              {moment(order.createdAt).format('lll')}
                            </span>
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="wgthead--elemnt">
                            <h4 className="sub-title-invoce">INVOICE NO</h4>
                            <span className="ttx-small-mtw">{
                              order.invoice
                            }</span>
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="address-content-wgt">
                            <div className="wgthead--elemnt">
                              <h4 className="sub-title-invoce">INVOICE TO</h4>
                            </div>
                            <ul className="multi-adrs-wt">
                              <li className="item-addres">{
                                order.user_info && order.user_info.firstName}   {order.user_info &&  order.user_info.lastName
                              }</li>
                              <li className="item-addres">{order.user_info && order.user_info.email} , {order.user_info && order.user_info.contact}</li>
                              <li className="item-addres">{order.user_info && order.user_info.address}</li>
                              <li className="item-addres">{order.user_info &&  order.user_info.city}, {order.user_info &&  order.user_info.state}, {order.user_info && order.user_info.country}, {order.user_info && order.user_info.zipCode}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="step-oder3 mb-4">
                      <div className="tableList-waper">
                        <Table bordered responsive className="orderTable-List mb-0">
                          <thead className="table-header">
                            <tr>
                              <th>SR.</th>
                              <th>PRODUCT TITLE</th>
                              <th className="text-center">QUANTITY</th>
                              <th className="text-center">ITEM PRICE</th>
                              <th className="text-center">ITEM DISCOUNT</th>
                              <th className="text-end">AMOUNT</th>
                            </tr>
                          </thead>
                          <tbody className="table-body">
                            {
                              order && order.cart && order.cart.map( (val, index) =>{
                                return(
                                  <tr>
                                  <td>{index + 1}</td>
                                  <td>{val.title}</td>
                                  <td className="text-center"><span className="txt-mtcl1">{val.quantity}</span></td>
                                  <td className="text-center"><span className="txt-mtcl1">₹{val.originalPrice}</span></td>
                                  <td className="text-center"><span className="txt-mtcl1">₹{val.discount}</span></td>
                                  <td className="text-end"><span className="txt-mtcl2">₹{val.price * val.quantity}</span></td>

                                </tr>
                                )
                              })
                            }
              
                          </tbody>
                        </Table>
                      </div>
                    </div>
                    <div className="step-oder4">
                      <div className="paymenstatus-waper">
                        <div className="row">
                          <div className="col-12 col-md-6 col-lg-2">
                            <div className="wgt-pymt-box">
                              <h3 className="title-mt-ptm">PAYMENT METHOD</h3>
                              <span className="small-itemtxt-wgt">{
                                order.paymentMethod
                              }</span>
                            </div>
                          </div>

                          <div className="col-12 col-md-6 col-lg-2">
                            <div className="wgt-pymt-box">
                              <h3 className="title-mt-ptm">SUB TOTAL</h3>
                              <span className="small-itemtxt-wgt">₹{
                               order.subTotal ? (order.subTotal).toFixed(2) : 0
                              }</span>
                            </div>
                          </div>

                          <div className="col-12 col-md-6 col-lg-2">
                            <div className="wgt-pymt-box">
                              <h3 className="title-mt-ptm">DISCOUNT</h3>
                              <span className="small-itemtxt-wgt">₹{
                              order.discount ?   (order.discount).toFixed(2) : 0
                              }</span>
                            </div>
                          </div>

                          <div className="col-12 col-md-6 col-lg-2">
                            <div className="wgt-pymt-box">
                              <h3 className="title-mt-ptm">TAX</h3>
                              <span className="small-itemtxt-wgt">₹{
                               order.tax ? (order.tax).toFixed(2) : 0
                              }</span>
                            </div>
                          </div>

                          <div className="col-12 col-md-6 col-lg-2">
                            <div className="wgt-pymt-box">
                              <h3 className="title-mt-ptm">DELIVERY</h3>
                              <span className="small-itemtxt-wgt">₹60.00</span>
                            </div>
                          </div>
                  
                          <div className="col-12 col-md-6 col-lg-2">
                            <div className="wgt-pymt-box">
                              <h3 className="title-mt-ptm">TOTAL AMOUNT</h3>
                              <span className="small-itemtxt-wgt extra-size-ft">₹{
                                order.total ?  (order.total).toFixed(2) : 0
                              }</span>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <PDFDownloadLink
                className="mt-4"
                document={
                  <InvoiceForDownload

                  />
                }
                fileName="Invoice"
              >
                <button className="btn btn-invoice-btn">
                  Download Invoice
                  <DownloadIcon />
                  {/* <span className="ml-2 text-base">
                                                <IoCloudDownloadOutline />
                                            </span> */}
                </button>
              </PDFDownloadLink>


            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  )
}
export default Cartpage